const getAwardData = state => {
  return formatAwardData(state.AwardReducer.awards);
};

const getAwardLoading = state => {
  return state.AwardReducer.loading.awards;
};

const getAwardError = state => {
  return state.AwardReducer.error.awards;
};

const isLoading = state => {
  return getAwardLoading(state);
};

const formatAwardData = awards_data => {
  const data = awards_data && awards_data.data;
  const vertical_id = awards_data && awards_data.vertical_id;
  const project_url_slug = awards_data && awards_data.project_url_slug;
  let awards = [];
  const media_path = data && data.media_path;
  const web = data && data.device && data.device.web;
  const mobile = data && data.device && data.device.mobile;
  const thumbnail = data && data.device && data.device.thumbnail;
  data &&
    data.more_awards.map(data => {
      if (data.vertical_id === vertical_id) {
        if (!project_url_slug) {
          awards = insertData(
            data,
            media_path,
            web,
            mobile,
            awards,
            thumbnail,
            true
          );
        } else if (data.project && data.project.url_slug === project_url_slug) {
          awards = insertData(
            data,
            media_path,
            web,
            mobile,
            awards,
            thumbnail,
            false
          );
        }
      }
    });
  return awards;
};

const insertData = (
  data,
  media_path,
  web,
  mobile,
  awards,
  thumbnail,
  isProjectNameVisible
) => {
  let awards_selected = awards ? awards : [];
  let result;
  if (data.project_id) {
    result = {
      project_name: data.project.project_details[0].project_name,
      project_id: data.project_id,
      award_name: data.award_name,
      awarded_on: data.awarded_on,
      awarded_at: data.awarded_at,
      authority: data.authority,
      city_name: data.project.city.city_name,
      picture: data.picture,
      overlay_picture: `${media_path}${web}/${data.picture}`,
      media_path: media_path,
      web: web,
      thumbnail: thumbnail,
      mobile: mobile,
      award_heading: data.award_heading,
      award_description: data.award_description,
      mobile_picture: `${media_path}${mobile}/${data.mobile_picture}`,
      media_path_thumbnail_mobile: `${media_path}${thumbnail}/${data.mobile_picture}`,
      isProjectNameVisible,
    };
  } else {
    result = {
      award_name: data.award_name,
      awarded_on: data.awarded_on,
      awarded_at: data.awarded_at,
      authority: data.authority,
      picture: data.picture,
      media_path: media_path,
      web: web,
      thumbnail: thumbnail,
      mobile: mobile,
      award_heading: data.award_heading ? data.award_heading : '',
      award_description: data.award_description,
      overlay_picture: `${media_path}${web}/${data.picture}`,
      mobile_picture: `${media_path}${web}/${data.mobile_picture}`,
      project_id: data.project_id,
      media_path_thumbnail_mobile: `${media_path}${thumbnail}/${data.mobile_picture}`,
      isProjectNameVisible,
    };
  }

  awards_selected.push(result);
  return awards_selected;
};

export const AwardSelector = {
  getAwardData,
  getAwardLoading,
  getAwardError,
  isLoading,
};
